import {
  FormPasswordField as ExprWorksFormPasswordField,
  FormPasswordFieldBaseProps as ExprWorksFormPasswordFieldBaseProps,
} from '@diagentech/exprworks-ui-components';
import React, { FC } from 'react';

import { withDisplayRule } from '@/features/displayRules/withDisplayRule';

type FormPasswordFieldBaseProps = Omit<ExprWorksFormPasswordFieldBaseProps, 'ariaLabelId'>;

export const FormPasswordFieldBase: FC<FormPasswordFieldBaseProps> = (props) => (
  <ExprWorksFormPasswordField {...props} ariaLabelId="SH.ARIA.SHOWHIDEPASSWORD" />
);

export const FormPasswordField = withDisplayRule(FormPasswordFieldBase);
